import React, { useState, createRef, useEffect } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useScreenshot } from "use-react-screenshot";
import CropEasy from "./Components/crop/CropEasy";
import { BsFillCloudUploadFill } from "react-icons/bs";
import Loader from "./Components/Loader";
import "./assets/style/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Post from "./Components/PostSVG/Post";
import { Box } from "@mui/material";
import YogaStory from "./Components/PostSVG/YogaStory";

function Yoga() {
    const ref = createRef(null);
    const [state, setState] = useState({
        venue: "",
        time: "",
        contactNo: "",
    });
    const [image, takeScreenShot] = useScreenshot({
        type: "image/png",
        quality: 10,
    });
    const [isLoading, setIsLoading] = useState(false);
    const [screenshotCount, setScreenshotCount] = useState(0);
    const [showHiddenDiv, setShowHiddenDiv] = useState(false);

    const downloadScreenshot = async () => {
        setIsLoading(true);
        setShowHiddenDiv(true);
        setScreenshotCount((prev) => prev + 1);
        await takeScreenShot(ref.current)
            .then((img) => {
                if (screenshotCount === 1) {
                    const link = document.createElement("a");
                    link.href = img;
                    link.download = `Yoga_Day.png`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    setScreenshotCount(0);
                    setShowHiddenDiv(false);
                }
            })
            .catch((err) => console.error("Screenshot error:", err))
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        if (screenshotCount === 1 && showHiddenDiv) {
            downloadScreenshot();
        }
    }, [screenshotCount, showHiddenDiv]);

    const isDownloadReady = state.venue && state.time && state.contactNo;

    return (
        <div className="App">
            <div className="nav w-100 header-sticky">
                <h2 className="nav_head">Webito Infotech Invitation</h2>
            </div>
            <Container>
                <Row>
                    <Col className="col-12 col-md-6 form_main mb-5">
                        <Form className="form_data">
                            <Form.Group className="form_C form_name">
                                <Form.Label>Venue</Form.Label>
                                <Form.Control
                                    type="text"
                                    onChange={(e) =>
                                        setState({
                                            ...state,
                                            venue: e.target.value,
                                        })
                                    }
                                    maxLength={220}
                                    max={220}
                                    name="venue"
                                    value={state.venue}
                                    placeholder="Enter the venue"
                                />
                            </Form.Group>
                            <Form.Group className="mt-3 form_C form_name">
                                <Form.Label>Time</Form.Label>
                                <Form.Control
                                    type="time"
                                    name="time"
                                    value={state.time24 || ""}
                                    onChange={(e) => {
                                        const time24 = e.target.value;

                                        const [hour, minute] = time24.split(":");
                                        const date = new Date();
                                        date.setHours(hour);
                                        date.setMinutes(minute);

                                        const time12 = date.toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                        });

                                        setState({
                                            ...state,
                                            time: time12,
                                            time24: time24,
                                        });
                                    }}
                                />
                            </Form.Group>
                            <Form.Group className="mt-3 form_C form_name">
                                <Form.Label>Contact No</Form.Label>
                                <Form.Control
                                    type="tel"
                                    onChange={(e) =>
                                        setState({
                                            ...state,
                                            contactNo: e.target.value,
                                        })
                                    }
                                    maxLength={15}
                                    max={15}
                                    name="contactNo"
                                    value={state.contactNo}
                                    placeholder="Enter the contact number"
                                />
                            </Form.Group>
                            <Button
                                type="button"
                                className="mt-3 form_button"
                                style={{
                                    backgroundColor: "#0c6566",
                                    borderColor: "#0c6566",
                                }}
                                onClick={downloadScreenshot}
                                disabled={isLoading || !isDownloadReady}
                            >
                                {isLoading ? "Loading......" : "Download"}
                            </Button>
                        </Form>
                    </Col>
                </Row>
                <Box sx={{ marginTop: { lg: "0px", md: "0px", sm: "0px", xs: '150px' } }}>
                    <Col
                        className="col-10 d-flex col-md-10"
                    >
                        <div ref={ref}>
                            <YogaStory
                                venue={state.venue}
                                time={state.time}
                                contactNo={state.contactNo}
                            />
                        </div>
                    </Col>
                </Box>

            </Container>
        </div>
    );
}

export default Yoga;